export function bigIntToWei(bigInt: string, decimal: number) {
  const padding = '0'.repeat(decimal)
  let index = bigInt.indexOf('.')
  if (index === -1) {
    index = bigInt.length
  }
  const move = index + decimal
  bigInt = bigInt.replace('.', '') + padding
  return bigInt.slice(0, move)
}
